import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=1b93c574"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b93c574')) {
      api.createRecord('1b93c574', component.options)
    } else {
      api.reload('1b93c574', component.options)
    }
    module.hot.accept("./BaseInput.vue?vue&type=template&id=1b93c574", function () {
      api.rerender('1b93c574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseInput.vue"
export default component.exports